<div [formGroup]="form">
  <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-5" *ngIf="_campaignType!= campaignTypeEnum['Ticketing']">

    <!-- @if(listingTypeId === itemListingTypeEnum.Custom){ -->
      <!-- <div class="sml-control-group tw-col-span-2">
      <label for="online-payment" class="sml-label">Accept Online Payment <sup class="tw-text-alert-800">*</sup></label>

      <sml-radio-button [options]="booleanEnum" [customClass]="'tw-grid-cols-2'" [disabledOptions]="disabledOption" formControlName="onlinePayment" groupIdentifier="online-payment" 
      ></sml-radio-button>
      <div *ngIf="control['onlinePayment'].touched && control['onlinePayment'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
      </div>
    </div> -->
   
      <!-- <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="price" class="sml-label">Donation Amounts <sup class="tw-text-alert-800">*</sup></label>
        <label for="customMinPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMinPrice" formControlName="customMinPrice" placeholder="Min Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['customMinPrice'].invalid && (control['customMinPrice'].dirty || control['customMinPrice'].touched)}" />
        </label>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Min donation is required
        </div>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Min donation cannot be less than 1
        </div>
      </div>
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label *ngIf="!isMobileView" for="price" class="sml-label">&nbsp;</label>
        <label for="customMaxPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMaxPrice" formControlName="customMaxPrice" placeholder="Max Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': (control['customMaxPrice'].invalid || form.errors?.['invalidPriceRange']) && (control['customMaxPrice'].dirty || control['customMaxPrice'].touched)}" />
        </label>
        @if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['required']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation is required
          </div>
        }
        @else if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['min']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation cannot be less than 1
          </div>
        }
        @else if(control['customMaxPrice'].touched && form.errors?.['invalidPriceRange']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation must be greater than min donation
          </div>
        }
      </div> -->
    <!-- } -->
    @if(!isVolunteerActivity){
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1" *ngIf="listingTypeId !== itemListingTypeEnum.Multiple && listingTypeId !== itemListingTypeEnum.Custom"
      >
        <label for="price" class="sml-label">Price Per Item <sup *ngIf="showPricePerItem"  class="tw-text-alert-800">*</sup></label>
        <label for="priceInput" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="priceInput" formControlName="price" placeholder="Enter" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['price'].invalid && (control['price'].dirty || control['price'].touched)}"
            (input)="onPriceChange($event)" />

        </label>

        <div *ngIf="control['price'].touched && control['price'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Price is required
        </div>
        <div *ngIf="control['price'].touched && control['price'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Price cannot be less than 1
        </div>
      </div>
      <!-- <div class="sml-control-group" [ngClass]="{'tw-col-span-2':listingTypeId === itemListingTypeEnum.Multiple,
        'tw-col-span-1 max-md:tw-col-span-2': listingTypeId !== itemListingTypeEnum.Multiple
      }" >
        <label for="online-payment" class="sml-label">Accept Online Payment <sup class="tw-text-alert-800">*</sup></label>

        <sml-radio-button [options]="booleanEnum" [customClass]="'tw-grid-cols-2'" formControlName="onlinePayment" groupIdentifier="online-payment" 
        ></sml-radio-button>
        <div *ngIf="control['onlinePayment'].touched && control['onlinePayment'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
        </div>
      </div> -->
      <div class="tw-flex tw-items-center tw-gap-[10px] tw-col-span-2">
        <div class="tw-font-bold tw-text-sm tw-text-[#041519]">
          {{getFieldName()}} <sup class="tw-text-alert-800">*</sup>
        </div>
        <div
              class="tw-flex tw-border-mercury-200"
             
            >
              <sml-tabs
                [tabs]="sections"
                [activeTab]="currentTab"
                [variation]="'filled'"
                [customclassesForTab]="true"
                (activeTabChange)="activeSection($event)"
              ></sml-tabs>
            </div>
      </div>
    }
    


    <div class="sml-control-group tw-col-span-2 tw-grid tw-grid-cols-2 tw-gap-4" *ngIf="listingTypeId === itemListingTypeEnum.Multiple || listingTypeId === itemListingTypeEnum.Custom">
      @if(currentTab==='Set Price'){
      <div class="sml-control-group max-md:tw-col-span-2" *ngIf="!isVolunteerActivity">
     
        <label for="priceInput" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="priceInput" formControlName="price" placeholder="Enter" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['price'].invalid && (control['price'].dirty || control['price'].touched)}"
            (input)="onPriceChange($event)" />
        </label>

        <div *ngIf="control['price'].touched && control['price'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Price is required
        </div>
        <div *ngIf="control['price'].touched && control['price'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Price cannot be less than 1
        </div>
      </div>
    }
    @if(currentTab==='Price Range'){
   
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="customMinPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMinPrice" formControlName="customMinPrice" placeholder="Min Price" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['customMinPrice'].invalid && (control['customMinPrice'].dirty || control['customMinPrice'].touched)}" />
        </label>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Min price is required
        </div>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Min price cannot be less than 1
        </div>
      </div>
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="customMaxPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMaxPrice" formControlName="customMaxPrice" placeholder="Max Price" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': (control['customMaxPrice'].invalid || form.errors?.['invalidPriceRange']) && (control['customMaxPrice'].dirty || control['customMaxPrice'].touched)}" />
        </label>
        @if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['required']){
          <div class="tw-text-alert-800 sml-form-error">
            Max price is required
          </div>
        }
        @else if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['min']){
          <div class="tw-text-alert-800 sml-form-error">
            Max price cannot be less than 1
          </div>
        }
        @else if(control['customMaxPrice'].touched && form.errors?.['invalidPriceRange']){
          <div class="tw-text-alert-800 sml-form-error">
            Max price must be greater than min price
          </div>
        }
      </div>
    }
      <div class="sml-control-group tw-col-span-2" 
     *ngIf="isVolunteerActivity">
      <label for="payment-details" class="sml-new-label">Activity Type<sup class="tw-text-alert-800">*</sup></label> 
      <span class="tw-text-grey-950 "  [smlTooltip]="'Does your volunteer event have a single sign-up option or multiple shifts?'" [placement]="'bottom'" mode="always">
         <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3" ></i-icon>
        </span>
       
      <sml-toggle-radio-button [options]="participationDetailEnum" [customClass]="'tw-grid-cols-2'" formControlName="hasVolunteerShifts" groupIdentifier="payment-details"  [disabledOptions]="shiftDisableOption"
      [combinedViewWithButton]="true"
      ></sml-toggle-radio-button>
      <div *ngIf="showShiftError" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Please add at least one shift</span>
      </div>
      <div *ngIf="control['hasVolunteerShifts'].touched && control['hasVolunteerShifts'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
      </div>
    </div>
      <div [ngClass]="{'tw-col-span-2': isVolunteerActivity && showTotalVolunteers==false,
        'max-md:tw-col-span-2':!isVolunteerActivity && currentTab==='Set Price'
      }">
   @if(isVolunteerActivity && showTotalVolunteers){
    <div class="tw-flex tw-flex-col tw-gap-1">

      @if (isEditItem) {
        <label for="price" class="sml-new-label">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}}
          <sup  class="tw-text-alert-800">*</sup>
        </label>
        <!-- <label for="remainingQuantityInput" class="tw-relative tw-w-full tw-block"></label>
        <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon> -->
        <input type="number" min="0" id="remainingQuantityInput" formControlName="remainingQuantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
        [ngClass]="{'sml-control-error': control['remainingQuantity'].invalid && (control['remainingQuantity'].dirty || control['remainingQuantity'].touched)}" />
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} is required
        </div>
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} cannot be less than 1
        </div>
      }
      @else {
        <label for="price" class="sml-new-label">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}}
          <sup class="tw-text-alert-800">*</sup>
        </label>
        <!-- <label for="quantityInput" class="tw-relative tw-w-full tw-block"></label>
        <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon> -->
        <input type="number" min="0" id="quantityInput" formControlName="quantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
          [ngClass]="{'sml-control-error': control['quantity'].invalid && (control['quantity'].dirty || control['quantity'].touched)}" />
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} is required
        </div>
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} cannot be less than 1
        </div>
      }
      <div class="tw-flex tw-gap-1 tw-items-center">
        <input type="checkbox" 
               class="!tw-h-[18px] !tw-w-[18px]"
               formControlName="isUnlimitedParticipation"
               (change)="onUnlimitedParticipationChange($event)"/>
        <div class="tw-text-[#828485] tw-text-xs tw-font-medium">
          Unlimited quantity?
        </div>
      </div>
    </div>

    }
    @else if(isVolunteerActivity && showTotalVolunteers==false){

        <sml-item-participation-details 
          [contacts]="VolunteerData" 
          (shiftsChange)="onVolunteerShiftsChange($event)"
          [drawerSize]="drawerSize"
          [isMobile]="isMobileView"
          [isNewFlag]="isNewFlag">
        </sml-item-participation-details>
      
        
    }
    
    @else if(!isVolunteerActivity && currentTab==='Set Price') {
      <div class="tw-flex tw-flex-col tw-gap-1">
      @if (isEditItem) {
        
        <input type="number" min="0" id="remaningQuantityInput" formControlName="remainingQuantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
        [ngClass]="{'sml-control-error': control['remainingQuantity'].invalid && (control['remainingQuantity'].dirty || control['remainingQuantity'].touched)}" />
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} is required
        </div>
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} cannot be less than 1
        </div>
                  
      }
      @else {
        
        <input type="number" min="0" id="quantityInput" formControlName="quantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
          [ngClass]="{'sml-control-error': control['quantity'].invalid && (control['quantity'].dirty || control['quantity'].touched)}" />
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} is required
        </div>
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} cannot be less than 1
        </div>

      }
      <div class="tw-flex tw-gap-1 tw-items-center">
        <input type="checkbox" 
               class="!tw-h-[18px] !tw-w-[18px]"
               formControlName="isUnlimitedParticipation"
               (change)="onUnlimitedParticipationChange($event)"/>
        <div class="tw-text-[#828485] tw-text-xs tw-font-medium">
          Unlimited quantity?
        </div>
      </div>
    </div>

    }
  
    </div>
    </div>
    @if(!isVolunteerActivity && campaignType!==campaignTypeEnum['Interactive Tour']){
      <div class="tw-flex tw-mt-6  max-md:tw-col-span-2">
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div class="tw-flex tw-gap-5">
            <sml-toggle-button formControlName="onlinePayment"
            groupidentifier="onlinePayment"></sml-toggle-button>
          <div class="tw-text-sm tw-font-bold">
            <div class="tw-flex tw-items-center tw-gap-1">
              <div>
                Accept Online Payment
              </div>
              <i-icon [name]="'info'" class="!tw-w-4 !tw-h-4" [smlTooltip]="'Enabling online payment will allow your participants to pay conveniently online.'" [placement]="'bottom'" mode="always"></i-icon>
            </div>
            
          </div>
          </div>
          <div class="tw-text-xs tw-font-medium tw-text-[#828485]">
            Collect payments through SeeMyLegacy
          </div>
    
      </div>
      
    </div>
    }
    <!-- <div class="sml-control-group tw-col-span-2">
      <label for="participationMethod" class="sml-label !tw-mb-0">Participation Method <sup class="tw-text-alert-800">*</sup></label>
      <p class="tw-text-grey-600 tw-text-sm tw-font-normal tw-leading-snug">
        Choose how you want community members to participate in this Campaign Item
      </p>

      <div class="tw-relative tw-mt-4" (smlClickOutside)="hideParticipationDropdown()">
        <button type="button" class="tw-h-12 tw-p-3 tw-w-full tw-bg-white tw-rounded-lg tw-border tw-border-mercury-200 tw-justify-between tw-items-center tw-gap-2 tw-flex disabled:tw-text-[#828485] disabled:tw-bg-[#F8F8F8] disabled:tw-cursor-not-allowed"
          (click)="toggleParticipationDropdown()"
          [disabled]="listingTypeId === itemListingTypeEnum.Custom"
          [ngClass]="{'sml-control-error': control['participationMethod'].invalid && (control['participationMethod'].dirty || control['participationMethod'].touched)}">
          <span class="tw-black tw-text-sm tw-font-medium tw-leading-tight tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis" [smlTooltip]="getSelectedOption()"
          [ngClass]="{'!tw-text-mercury-600': !control['participationMethod'].value}">{{getSelectedOption()}}</span>
          <i-icon [name]="'chevron-down'" [height]="'tw-h-4'" [width]="'tw-w-4'" class="tw-text-mercury-600 tw-flex-grow-0 tw-flex-shrink-0 tw-basis-4"></i-icon>
        </button>
        @if(showParticipationDropdown){
        <ul class="tw-absolute tw-top-full tw-left-0 tw-w-full tw-py-1 tw-bg-white tw-border tw-border-mercury-200 tw-rounded-xl tw-shadow tw-z-10">
          @for (item of participationOptions; track item.id) {
          <li>
            <label class="tw-block tw-w-full group">
              <input type="radio"  name="participationMethod" [value]="item.id" class="tw-absolute tw-opacity-0 tw-invisible"
                (change)="handleParticipationChange(item)">
              <div class="tw-flex tw-items-start tw-gap-2 tw-cursor-pointer tw-py-2.5 tw-px-3 tw-transition-all hover:tw-bg-mercury-100"
              [ngClass]="{
                'tw-cursor-not-allowed': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection,
                'tw-cursor-pointer': !(item.id === participationMethods.CustomForm && !isAllowCustomFormSelection)
              }">
                <i-icon [name]="item.icon" [height]="'tw-h-4'" [width]="'tw-w-4'" class="tw-text-mercury-600"></i-icon>
                <div>
                  <h5 class="tw-text-black tw-leading-none tw-font-medium tw-text-sm tw-mb-1.5"
                  [ngClass]="{'!tw-text-mercury-600': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection}">{{item.title}}</h5>
                  <p class="tw-text-mercury-950 tw-text-xs tw-font-normal tw-leading-snug"
                  [ngClass]="{'!tw-text-mercury-600': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection}">{{item.subtitle}}</p>
                </div>
              </div>
            </label>
          </li>
          }
        </ul>
        }
      </div>
      <div *ngIf="control['participationMethod'].touched && control['participationMethod'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        Participation Method is required
      </div>
    </div> -->
  </div>
  <div *ngIf="_campaignType === campaignTypeEnum['Ticketing']" class="tw-flex tw-flex-col tw-mt-5">

    <div class="tw-grid tw-grid-cols-2"> 
    <!-- Ticket Pricing radio-list -->
    <div class="tw-flex tw-flex-col tw-gap-2 tw-pb-6 max-md:tw-pb-[17px] tw-border-b tw-border-dashed tw-border-[#e3e3e3] tw-col-span-2">
      <div class="tw-font-bold tw-text-sm tw-text-[#041519]">
        Ticket Pricing <sup class="tw-text-alert-800">*</sup>
      </div>

      <div class="tw-border tw-border-[#e3e3e3] tw-rounded-lg tw-overflow-hidden">

          <!-- FIXED PRICE row -->
        <div class="tw-border-b tw-border-[#e3e3e3] tw-cursor-pointer"
             [ngClass]="currentTicketingTab === ticketingEnum.setPrice ? 'tw-bg-[#f0f7fb]' : 'tw-bg-white'">
          <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-4"
               [ngClass]="currentTicketingTab === ticketingEnum.setPrice ? 'max-md:tw-flex-col max-md:tw-items-start' : ''"
               (click)="activeSection(ticketingEnum.setPrice, true)">
            <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0 max-md:tw-w-full">
              <input type="radio" class="!tw-w-[22px] !tw-h-[22px] tw-shrink-0 tw-cursor-pointer tw-accent-[#106B8E]"
                     [checked]="currentTicketingTab === ticketingEnum.setPrice" readonly>
              <div class="tw-flex tw-flex-1 tw-min-w-0"
                   [ngClass]="currentTicketingTab === ticketingEnum.setPrice ? 'tw-gap-[5px] tw-items-center max-md:tw-flex-col max-md:tw-items-start max-md:tw-gap-0' : 'tw-gap-[5px] tw-items-center'">
                <span class="tw-font-bold tw-text-sm tw-text-[#3c4243] tw-shrink-0">Fixed price</span>
                <span class="tw-text-xs tw-font-normal tw-text-[#828485] tw-leading-[18px]">Everyone pays the same amount</span>
              </div>
            </div>
            @if(currentTicketingTab === ticketingEnum.setPrice) {
              <div class="tw-flex tw-items-center tw-gap-2 tw-pl-[30px] tw-flex-1 tw-min-w-0 max-md:tw-w-full max-md:tw-flex-none" (click)="$event.stopPropagation()">
                <span class="tw-font-bold tw-text-xs tw-text-[#041519] tw-shrink-0">Price per Ticket</span>
                <div class="tw-flex-1 tw-min-w-0 sml-control-group">
                  <label class="tw-relative tw-w-full tw-block">
                    <i-icon [name]="'dollar'" class="!tw-w-[18px] !tw-h-[18px] tw-text-mercury-600 tw-absolute tw-top-[16px] tw-left-3"></i-icon>
                    <input type="number" min="2" id="priceInput" formControlName="price"
                           placeholder="Enter Price"
                           class="sml-control !tw-pl-8"
                           smlInputNumber
                           [ngClass]="{'sml-control-error': control['price'].invalid && (control['price'].dirty || control['price'].touched)}"
                           (input)="onPriceChange($event)" />
                  </label>
                  <div *ngIf="control['price'].touched && control['price'].errors?.['required']" class="tw-text-alert-800 sml-form-error">Price is required</div>
                  <div *ngIf="control['price'].touched && control['price'].errors?.['min']" class="tw-text-alert-800 sml-form-error">Price cannot be less than 2</div>
                </div>
              </div>
            }
          </div>
          @if(currentTicketingTab === ticketingEnum.setPrice) {
            <div class="tw-border-t tw-border-dashed tw-border-[#e3e3e3] tw-mx-3"></div>
            <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-px-3 tw-py-2 tw-pb-4">
              <div class="tw-flex tw-items-center tw-gap-1">
                <i-icon [name]="'small-tick'" class="!tw-w-2 !tw-h-2"></i-icon>
                <span class="tw-text-[10px] tw-leading-[16px]">
                  <span class="tw-font-bold tw-text-[#041519]">Online payments enabled.</span>
                  <span class="tw-font-medium tw-text-[#828485]"> Ticket and processing fees apply.</span>
                </span>
              </div>
              <div class="tw-flex tw-gap-1">
                <div class="tw-bg-[#ebffee] tw-rounded tw-h-4 tw-px-2 tw-flex tw-items-center tw-gap-1">
                  <i-icon [name]="'circle-percentage'" class="!tw-w-[14px] !tw-h-[14px]"></i-icon>
                  <span class="tw-text-[10px] tw-leading-[16px] tw-text-[#041519]"><span class="tw-font-bold">3.4% + $0.30</span><span class="tw-font-medium"> processing</span></span>
                </div>
                <div class="tw-bg-[#ebffee] tw-rounded tw-h-4 tw-px-2 tw-flex tw-items-center tw-gap-1">
                  <i-icon [name]="'small-ticket'" class="!tw-w-[14px] !tw-h-[14px]"></i-icon>
                  <span class="tw-text-[10px] tw-leading-[16px] tw-text-[#041519]"><span class="tw-font-bold">$1 / ticket </span><span class="tw-font-medium">service</span></span>
                </div>
              </div>
            </div>
          }
        </div>
              <!-- DISCOUNT GROUPS row -->
        <div [ngClass]="currentTicketingTab === ticketingEnum.discountGroups ? 'tw-bg-[#f0f7fb]' : 'tw-bg-white'">
          <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-4 tw-cursor-pointer"
               [ngClass]="currentTicketingTab === ticketingEnum.discountGroups ? 'max-md:tw-flex-col max-md:tw-items-start' : ''"
               (click)="activeSection(ticketingEnum.discountGroups, true)">
            <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0 max-md:tw-w-full">
              <input type="radio" class="!tw-w-[22px] !tw-h-[22px] tw-shrink-0 tw-cursor-pointer tw-accent-[#106B8E]"
                     [checked]="currentTicketingTab === ticketingEnum.discountGroups" readonly>
              <div class="tw-flex tw-flex-1 tw-min-w-0"
                   [ngClass]="currentTicketingTab === ticketingEnum.discountGroups ? 'tw-gap-[5px] tw-items-center max-md:tw-flex-col max-md:tw-items-start max-md:tw-gap-0' : 'tw-gap-[5px] tw-items-center'">
                <span class="tw-font-bold tw-text-sm tw-text-[#3c4243] tw-shrink-0">Discount groups</span>
                <span class="tw-text-xs tw-font-normal tw-text-[#828485] tw-leading-[18px]">Set different prices per group (child, adult, senior...)</span>
              </div>
            </div>
          </div>

          @if(currentTicketingTab === ticketingEnum.discountGroups) {
            <!-- Groups table -->
            <div class="tw-bg-white tw-rounded-lg tw-mx-[10px] tw-mb-3">
              <!-- Header — desktop only -->
              <div class="max-md:tw-hidden tw-flex tw-items-center tw-px-2 tw-py-[6px]">
                <div class="tw-w-1/2 tw-font-bold tw-text-sm tw-text-[#041519] tw-flex tw-gap-1 tw-items-center tw-leading-[20px]">
                  Title of Group <sup class="tw-text-alert-800">*</sup>
                </div>
                <div class="tw-w-[30%] tw-font-bold tw-text-sm tw-text-[#3c4243] tw-text-center tw-leading-[20px]">
                  Price of Ticket <sup class="tw-text-alert-800">*</sup>
                </div>
                <div class="tw-flex-1 tw-font-bold tw-text-sm tw-text-[#3c4243] tw-leading-[20px] tablet:tw-flex tablet:tw-justify-center">
                  Actions
                </div>
              </div>
              <!-- Rows -->
              @for(group of ticketDiscountGroups; track $index) {
                <div class="tw-flex tw-items-center tw-border-t tw-border-[#ebebeb] tw-px-2 tw-py-1"
                     (click)="$event.stopPropagation()">
                  <!-- Title: 50% -->
                  <div class="tw-w-1/2 tw-min-w-0 tw-h-10 tw-flex tw-items-center">
                    <span class="tw-font-bold tw-text-sm tw-text-[#828485] tw-truncate tw-leading-[20px]" [smlTooltip]="group.title">
                      {{group.title}}
                    </span>
                  </div>
                  <!-- Price: 30% -->
                  <div class="tw-w-[30%] tw-h-10 tw-flex tw-items-center tw-justify-center">
                    @if(group.isFreeTicket) {
                      <span class="tw-font-bold tw-text-sm tw-text-[#828485] tw-leading-[20px]">FREE</span>
                    } @else {
                      <span class="tw-font-bold tw-text-sm tw-text-[#828485] tw-leading-[20px]"> {{group.price  | currency:'USD':'symbol':'1.0-0'}}</span>
                    }
                  </div>
                  <!-- Actions: remaining 20% -->
                  <div class="tw-flex-1 tw-h-10 tw-flex tw-items-center tw-justify-center">
                    <button type="button"
                            class="tw-flex tw-items-center tw-gap-2 tw-text-[#828485] tw-text-sm tw-font-medium tw-leading-[20px]"
                            (click)="openEditDiscountDrawer($event, group, $index)">
                      <i-icon [name]="'edit'" class="!tw-w-4 !tw-h-4 tw-text-[#828485]"></i-icon>
                      <span class="max-md:tw-hidden">Edit</span>
                    </button>
                  </div>
                </div>
              }
            </div>
            <div class="sml-control-group">
            <div *ngIf="showDiscountGroupError" class="tw-text-alert-800 sml-form-error tw-mx-3 tw-mb-2">
              <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Please add at least one group</span>
            </div>
            </div>
            <!-- Fee chips -->
             <div class="tw-flex max-md:tw-flex-col-reverse tablet:tw-justify-between tw-px-3 tw-pb-4">
            <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start">
              <div class="tw-flex tw-items-center tw-gap-1">
                <i-icon [name]="'small-tick'" class="!tw-w-2 !tw-h-2"></i-icon>
                <span class="tw-text-[10px] tw-leading-[16px]">
                  <span class="tw-font-bold tw-text-[#041519]">Online payments enabled.</span>
                  <span class="tw-font-medium tw-text-[#828485]"> Ticket and processing fees apply.</span>
                </span>
              </div>
              <div class="tw-flex tw-gap-1">
                <div class="tw-bg-[#ebffee] tw-rounded tw-h-4 tw-px-2 tw-flex tw-items-center tw-gap-1">
                  <i-icon [name]="'circle-percentage'" class="!tw-w-[14px] !tw-h-[14px]"></i-icon>
                  <span class="tw-text-[10px] tw-leading-[16px] tw-text-[#041519]"><span class="tw-font-bold">3.4% + $0.30</span><span class="tw-font-medium"> processing</span></span>
                </div>
                <div class="tw-bg-[#ebffee] tw-rounded tw-h-4 tw-px-2 tw-flex tw-items-center tw-gap-1">
                  <i-icon [name]="'small-ticket'" class="!tw-w-[14px] !tw-h-[14px]"></i-icon>
                  <span class="tw-text-[10px] tw-leading-[16px] tw-text-[#041519]"><span class="tw-font-bold">$1 / ticket </span><span class="tw-font-medium">service</span></span>
                </div>
              </div>
            </div>
             <button type="button"
                      class="tw-flex tw-items-center tw-gap-1 tw-shrink-0 max-md:tw-w-full max-md:tw-justify-center max-md:tw-border max-md:tw-border-dashed max-md:tw-border-[#e3e3e3] max-md:tw-rounded-lg max-md:tw-py-[10px]"
                      (click)="openAddDiscountDrawer($event)">
                <i-icon [name]="'plus-rounded'" class="!tw-w-4 !tw-h-4 tw-text-[#106b8e]"></i-icon>
                <span class="tw-text-xs tw-font-medium tw-text-[#106b8e] tw-leading-[18px]">Add New Group</span>
              </button>
            </div>
          }
        </div>

        <!-- FREE row -->
        <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-border-b tw-border-[#e3e3e3] tw-cursor-pointer"
             [ngClass]="currentTicketingTab === ticketingEnum.freeTicket ? 'tw-bg-[#f0f7fb] tw-py-4 max-md:tw-flex-col max-md:tw-items-start' : 'tw-py-2 tw-bg-white'"
             (click)="activeSection(ticketingEnum.freeTicket, true)">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0 max-md:tw-w-full">
            <input type="radio" class="!tw-w-[22px] !tw-h-[22px] tw-shrink-0 tw-cursor-pointer tw-accent-[#106B8E]"
                   [checked]="currentTicketingTab === ticketingEnum.freeTicket" readonly>
            <div class="tw-flex tw-flex-1 tw-min-w-0"
                 [ngClass]="currentTicketingTab === ticketingEnum.freeTicket ? 'tw-gap-[5px] tw-items-center max-md:tw-flex-col max-md:tw-items-start max-md:tw-gap-0' : 'tw-gap-[5px] tw-items-center'">
              <span class="tw-font-bold tw-text-sm tw-text-[#3c4243] tw-shrink-0">Free</span>
              <span class="tw-text-xs tw-font-normal tw-text-[#828485] tw-leading-[18px]">No charge – anyone can register at no cost</span>
            </div>
          </div>
          @if(currentTicketingTab === ticketingEnum.freeTicket) {
            <div class="tw-flex tw-items-center tw-gap-2 tw-pl-[30px] tw-flex-1 tw-min-w-0 max-md:tw-w-full max-md:tw-flex-none">
              <span class="tw-font-bold tw-text-xs tw-text-[#041519] tw-shrink-0">Price Per Ticket</span>
              <div class="tw-bg-[#f8f8f8] tw-border tw-border-[#e3e3e3] tw-rounded-lg tw-p-3 tw-flex tw-items-center tw-gap-2 tw-flex-1">
                <i-icon [name]="'dollar'" class="!tw-w-[18px] !tw-h-[18px] tw-text-mercury-600 tw-shrink-0"></i-icon>
                <span class="tw-text-xs tw-text-[#828485]">FREE</span>
              </div>
            </div>
          }
        </div>

      </div>
    </div>

    <!-- Number of Available Tickets (unchanged) -->
    <div class="tw-flex tw-flex-col tw-gap-1 sml-control-group tw-col-span-1 max-md:tw-col-span-2" [ngClass]="{'tw-mt-6 max-md:tw-mt-[17px]' : _campaignType === campaignTypeEnum['Ticketing']}">
      @if (isEditItem) {
        <label for="price" class="sml-new-label">
          Number of Available Tickets
          <sup class="tw-text-alert-800">*</sup>
        </label>
        <input type="number" min="0" id="remainingQuantityInput" formControlName="remainingQuantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
        [ngClass]="{'sml-control-error': control['remainingQuantity'].invalid && (control['remainingQuantity'].dirty || control['remainingQuantity'].touched)}" />
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Number of Available Tickets is required
        </div>
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Number of Available Tickets cannot be less than 1
        </div>
      }
      @else {
        <label for="price" class="sml-new-label">
          Number of Available Tickets
          <sup class="tw-text-alert-800">*</sup>
        </label>
        <input type="number" min="0" id="quantityInput" formControlName="quantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
          [ngClass]="{'sml-control-error': control['quantity'].invalid && (control['quantity'].dirty || control['quantity'].touched)}" />
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Number of Available Tickets is required
        </div>
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Number of Available Tickets cannot be less than 1
        </div>
      }
      <div class="tw-flex tw-gap-1 tw-items-center">
        <input type="checkbox"
               class="!tw-h-[18px] !tw-w-[18px]"
               formControlName="isUnlimitedParticipation"
               (change)="onUnlimitedParticipationChange($event)"/>
        <div class="tw-text-[#828485] tw-text-xs tw-font-medium">
          Unlimited quantity?
        </div>
      </div>
    </div>
</div>
  </div>


<!-- Discount Group Drawer -->
<sml-drawer
  [drawerType]="'side'"
  [size]="'lg'"
  *ngIf="isDiscountDrawerOpen"
  (close)="closeDiscountDrawer()"
  [drawerConatinerMain]="'!tw-bg-white'"
  [@slideInOut]
>
  <div class="tw-block" header>
    <div class="tw-flex tw-gap-2 tw-justify-between">
      <h3 class="tw-text-[#010f12] tw-text-xl tw-font-bold tw-leading-7 tw-mb-1">
        {{ isDiscountEdit ? 'Edit Group' : 'Add New Group' }}
      </h3>
      <button type="button" (click)="closeDiscountDrawer()">
        <i-icon name="close" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button>
    </div>
    <p class="tw-text-grey-750 tw-text-sm tw-leading-snug">
      {{ isDiscountEdit ? 'Edit the details of your Group.' : 'Fill out the details of your Group.' }}
    </p>
  </div>

  <div class="" body>
    <div [formGroup]="discountGroupForm">
      <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-mt-6">
        <div class="sml-control-group tw-col-span-1">
          <label for="groupName" class="sml-label">Title of Group <sup class="tw-text-alert-800">*</sup></label>
          <input
            id="groupName"
            formControlName="name"
            placeholder="Enter Title"
            type="text"
            class="sml-control"
            [ngClass]="{'sml-control-error': discountControl['name'].invalid && (discountControl['name'].dirty || discountControl['name'].touched)}"
          />
          <div class="sml-form-error" *ngIf="discountControl['name'].invalid && (discountControl['name'].dirty || discountControl['name'].touched)">
            <p *ngIf="discountControl['name'].errors?.['required']" class="tw-text-alert-800">This field is mandatory.</p>
          </div>
        </div>
        <div class="tw-col-span-1">
          <div class="tw-flex tw-items-center tw-gap-[10px]">
            <div class="tw-font-bold tw-text-sm tw-text-[#041519] md:tw-w-[292px]">
              Price Per Ticket <sup class="tw-text-alert-800">*</sup>
            </div>
            <sml-tabs
              [tabs]="discountPricingSections"
              [activeTab]="discountPricingTab"
              [variation]="'filled'"
              [customclassesForTab]="true"
              (activeTabChange)="onDiscountTabChange($event)"
            ></sml-tabs>
            @if(!isMobileView){
                 <div class="sml-control-group tw-w-full ">
              <label for="groupPrice" class="tw-relative tw-block"
                [ngClass]="{'tw-cursor-not-allowed': discountPricingTab === ticketingEnum.freeTicket}">
                <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
                <input
                  id="groupPrice"
                  formControlName="price"
                  type="text"
                  min="0"
                  smlInputNumber
                  [placeholder]="discountPricingTab === ticketingEnum.freeTicket ? 'FREE' : 'Enter Price'"
                  class="sml-control !tw-pl-8"
                  [readonly]="discountPricingTab === ticketingEnum.freeTicket"
                  [ngClass]="{'sml-control-error': discountControl['price'].invalid && (discountControl['price'].dirty || discountControl['price'].touched),
                              '!tw-bg-[#f8f8f8] tw-cursor-not-allowed': discountPricingTab === ticketingEnum.freeTicket}"
                />
              </label>
              <div class="sml-form-error" *ngIf="discountControl['price'].invalid && (discountControl['price'].dirty || discountControl['price'].touched)">
                <p *ngIf="discountControl['price'].errors?.['required']" class="tw-text-alert-800">This field is mandatory.</p>
                <p *ngIf="discountControl['price'].errors?.['min']" class="tw-text-alert-800">Price cannot be less than 2.</p>
              </div>
            </div>
            }
          </div>
          @if(isMobileView) {
            <div class="sml-control-group tw-mt-3">
              <label for="groupPrice" class="tw-relative tw-w-full tw-block"
                [ngClass]="{'tw-cursor-not-allowed': discountPricingTab === ticketingEnum.freeTicket}">
                <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
                <input
                  id="groupPrice"
                  formControlName="price"
                  type="text"
                  min="0"
                  [placeholder]="discountPricingTab === ticketingEnum.freeTicket ? 'FREE' : 'Enter Price'"
                  class="sml-control !tw-pl-8"
                  [readonly]="discountPricingTab === ticketingEnum.freeTicket"
                  [ngClass]="{'sml-control-error': discountControl['price'].invalid && (discountControl['price'].dirty || discountControl['price'].touched),
                              '!tw-bg-[#f8f8f8] tw-cursor-not-allowed': discountPricingTab === ticketingEnum.freeTicket}"
                />
              </label>
              <div class="sml-form-error" *ngIf="discountControl['price'].invalid && (discountControl['price'].dirty || discountControl['price'].touched)">
                <p *ngIf="discountControl['price'].errors?.['required']" class="tw-text-alert-800">This field is mandatory.</p>
                <p *ngIf="discountControl['price'].errors?.['min']" class="tw-text-alert-800">Price cannot be less than 2.</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div footer>
    @if(isDiscountEdit) {
      <!-- Mobile: Save on top, Delete Group + Cancel below -->
      <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full md:tw-hidden">
        <button type="button" smlButton="primary" [size]="'sm'" class="tw-w-full" (click)="saveDiscountGroupForm()">Save</button>
        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="tw-flex tw-items-center tw-gap-2 tw-text-[#D11A2A] tw-text-sm tw-font-medium tw-cursor-pointer" (click)="removeDiscountGroup()">
            <i-icon [name]="'trash'" class="!tw-w-4 !tw-h-4"></i-icon>
            <span>Delete Group</span>
          </div>
          <button type="button" smlButton="link" [size]="'sm'" (click)="closeDiscountDrawer()">Cancel</button>
        </div>
      </div>
      <!-- Desktop: original layout — Cancel + Delete group on left, Save on right -->
      <div class="tw-hidden md:tw-flex tw-flex-row tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-[40px]">
          <button type="button" smlButton="link" [size]="'sm'" (click)="closeDiscountDrawer()">Cancel</button>
          <div class="tw-flex tw-items-center tw-gap-[2px] tw-text-[#D11A2A] tw-text-sm tw-font-bold tw-cursor-pointer" (click)="removeDiscountGroup()">
            <i-icon [name]="'trash'" class="!tw-w-4 !tw-h-4"></i-icon>
            <div class="tw-font-medium">Delete group</div>
          </div>
        </div>
        <button type="button" smlButton="primary" [size]="'sm'" (click)="saveDiscountGroupForm()">Save</button>
      </div>
    } @else {
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
        <button type="button" smlButton="link" [size]="'sm'" (click)="closeDiscountDrawer()">Cancel</button>
        <button type="button" smlButton="secondary" [size]="'sm'" (click)="saveDiscountGroupForm()">Add Group</button>
      </div>
    }
  </div>
</sml-drawer>

</div>
<!-- <div class="tw-font-medium tw-text-sm tw-leading-[22px] tablet:tw-text-base tw-text-mercury-950 tw-pt-5">
  If you would like to collect more detailed information from your participants,
  contact our Support Team to request a Custom Form 👉🏼
  <a href="{{supportUrl}}" target="_blank" class="tw-font-bold tw-text-primary-700 tw-cursor-pointer">
    Contact support.
  </a>
</div> -->
